import React, { useContext } from "react";
import { ThemeContext } from "../../lib/main-context";

import Logo from "../../images/Logo.png";
import LogoWhite from "../../images/LogoWhite.png";
import LanguageSelector from "./LanguageSelector";

const Brand = () => {
  const { dark } = useContext(ThemeContext);

  return (
    <div className="flex flex-col items-center gap-2 mt-4 mb-2 md:flex-row md:justify-between md:mx-5">
      <img
        src={dark ? LogoWhite : Logo}
        className="w-60 h-auto md:w-75"
        alt="Power of Patients brand-img"
      />
      <LanguageSelector />
    </div>
  );
};

export default Brand;